import styled from "styled-components";

export const TableTitle = styled.h3`
    margin: 15px 0%;
    font-size: 1.17em !important;
`;
